/**
 *
 * @param {any} value
 * @returns {boolean}
 */
function toBoolean(value) {
  if (typeof value === 'boolean') return value;

  if (typeof value === 'string') {
    const lowerValue = value.trim().toLowerCase();
    return lowerValue === 'true' || lowerValue === 'yes' || lowerValue === '1';
  }

  if (typeof value === 'number') return value !== 0;

  return Boolean(value);
}

module.exports = toBoolean;